module.exports = __webpack_public_path__ + "static/img/glass.738e728.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/glass.png
// module id = 9dwa
// module chunks = 2